/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');
require('./jquery.ddslick.min');
$(function () {
    $(window).bind('load', function () {

        let name;
        let font;
        let fontName;

        $('#submit').on('click', function () {
            $('#download').hide();
            $('#submit').prop("disabled",true);
            name = $('#your_name').val();
            $('#download').hide();
            $('#image').hide();
            $('#wait').show();
            $('#image').attr('src', $('#url').data('url') + '?name=' + name + '&font=' + font);
            $('#download').attr('href', $('#image').attr('src'));
            $('#download').attr('download', name + '.png');
            setTimeout(function () {
                $('#image').show();
                $('#wait').hide();
                $('#download').show();
            }, 500);
            setTimeout(function () {
                $('#submit').prop("disabled",false);
            }, 2000);


            gtag('event', 'click', {
                'event_category': 'GO'
            });
        });


        $('#font-htmlselect').ddslick({
            width: "100%",
            onSelected: function (selectedData) {
                name = $('#name').val();
                font = selectedData.selectedData.value;
                fontName = selectedData.selectedData.text;
                if (name && font) {
                    $('#image').attr('src', $('#url').data('url') + '?name=' + name + '&font=' + font);
                    $('#download').attr('href', $('#image').attr('src'));
                }
            }
        });

        // loading apazi
        let s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://app.appzi.io/bootstrap/bundle.js?token=VsjRJ';
        let x = document.getElementsByTagName('head')[0];
        x.appendChild(s);

    });
});

